import { Auth } from 'aws-amplify'
export const getSessionTokens = async () => {
    try {
        const session = await Auth.currentSession()
        return {
            accessToken: session.getAccessToken().getJwtToken(),
            idToken: session.getIdToken().getJwtToken(),
            refreshToken: session.getRefreshToken().getToken()
        }
    } catch (error) {
        return null
    }
}
